import { WebshopProduct } from '@cldsystems/ws-api-client';
import { SortByItemKeys } from '@/types/common/sort-by-item-keys';
import { doesProductMatchFilter, isProductInPriceRanges } from '@/utils/applyed-filters';
import {
  getEffectiveCustomerPrice,
  type PriceFilterContext,
} from '@/utils/effective-product-price';

export const sortProducts = (
  products: WebshopProduct[],
  sortBy: SortByItemKeys,
  ctx?: PriceFilterContext | null,
): WebshopProduct[] => {
  return [...products].sort((a, b) => {
    const aPrice = getEffectiveCustomerPrice(a, ctx);
    const bPrice = getEffectiveCustomerPrice(b, ctx);
    switch (sortBy) {
      case SortByItemKeys.PRICE_LOW_TO_HIGH:
        return aPrice - bPrice;
      case SortByItemKeys.PRICE_HIGH_TO_LOW:
        return bPrice - aPrice;
      default:
        return 0;
    }
  });
};

export const applyFilters = (
  products: WebshopProduct[],
  appliedFilters: URLSearchParams,
  ctx?: PriceFilterContext | null,
): WebshopProduct[] => {
  const filterKeys = Array.from(appliedFilters.keys());

  return products.filter(product => {
    return filterKeys.every(key => {
      if (key === 'price') {
        const priceRanges = appliedFilters.getAll('price');
        return isProductInPriceRanges(product, priceRanges, ctx);
      } else {
        const filterValues = appliedFilters.getAll(key);
        return doesProductMatchFilter(product, key, filterValues);
      }
    });
  });
};

export const paginateProducts = (
  products: WebshopProduct[],
  currentPage: number,
  itemsPerPage: number,
): { paginatedProducts: WebshopProduct[]; totalPages: number } => {
  const totalPages = Math.ceil(products.length / itemsPerPage);
  const paginatedProducts = products.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
  return { paginatedProducts, totalPages };
};
